export default import.meta.ROLLDOWN_FILE_URL__L4B85Kg7_78CgH4If65XA